import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Route } from "react-router-dom";
import RunOffPageLayout from "../../layouts";
import { PageContext } from "../../../contexts";
import Helmet from "../Helmet";

const Page = (props) => {
  const {
    children,
    pageLayout,
    page: Component,
    path,
    title: pageTitle,
    disableNavigation,
    helmet,
    description,
    parentPage,
  } = props;

  const pageContext = useMemo(
    () => ({
      pageTitle,
      disableNavigation,
      path,
      helmet,
      description,
      parentPage,
    }),
    [pageTitle, disableNavigation, path, helmet, description, parentPage]
  );

  return (
    <Route path={path} exact>
      <PageContext.Provider value={pageContext}>
        {React.createElement(
          pageLayout,
          { ...props },
          <>
            <Helmet />
            {Component ? <Component {...props} /> : children}{" "}
          </>
        )}
      </PageContext.Provider>
    </Route>
  );
};

Page.defaultProps = {
  pageLayout: RunOffPageLayout,
  page: null,
  parentPage: null,
  description: null,
  disableNavigation: false,
  path: "",
  helmet: {},
};

Page.propTypes = {
  pageLayout: PropTypes.elementType,
  page: PropTypes.elementType,
  parentPage: PropTypes.string,
  path: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  disableNavigation: PropTypes.bool,
  helmet: PropTypes.shape({
    title: PropTypes.string,
    robots: PropTypes.string,
    description: PropTypes.string,
    keywords: PropTypes.string,
  }),
};

export default Page;
